import { type HTMLAttributes } from "react"

type SkeletonTextWrapperProps = HTMLAttributes<HTMLDivElement>

/**
 * A placeholder component that can be used to replace text or paragraphs of
 * text. For a more flexible component that can be used to replace any content,
 * consider using the Skeleton component.
 *
 * ```tsx
 * import { SkeletonTextWrapper } from "@tokenterminal/ui/progress/skeleton/SkeletonTextWrapper"
 *
 * <SkeletonTextWrapper width="100px" height="100px" />
 * ```
 */

export const SkeletonTextWrapper = (props: SkeletonTextWrapperProps) => {
  return (
    <div {...props}>
      <span className="tt-skeleton-text">{props.children}</span>
    </div>
  )
}
